import { Text } from "@chakra-ui/react";

export default function Caption({ children, reference, ...rest }) {
  return (
    <Text
      ref={reference}
      fontSize="1rem"
      lineHeight="1.4"
      letterSpacing="0.4px"
      {...rest}
    >
      {children}
    </Text>
  );
}
